// extracted by mini-css-extract-plugin
export default {"container":"NewCaseButton_container__EJcPL","disabled":"NewCaseButton_disabled__7TlTS"};